/* Jumbomaama theme - global.js (vanilla JS + web components, no dependencies) */
(function () {
  'use strict';

  var JM = (window.JM = window.JM || {});
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  JM.$ = $; JM.$$ = $$;

  /* ---------------------------------------------------------------- Scroll reveal (.jm-reveal -> .is-in) */
  var revealObserver = null;
  function initReveal(root) {
    root = root || document;
    $$('[data-reveal-stagger]', root).forEach(function (parent) {
      Array.prototype.forEach.call(parent.children, function (child, i) { child.style.setProperty('--i', i); });
    });
    var targets = $$('.jm-reveal:not(.is-in)', root);
    if (!targets.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
    }
    targets.forEach(function (el) { revealObserver.observe(el); });
  }
  JM.initReveal = initReveal;

  /* ---------------------------------------------------------------- <slider-component> */
  /* Two modes, detected from the track's computed overflow:
     - scroll mode: track is overflow auto/scroll (scroll-snap rows such as .jm-books, .slider__track)
     - transform mode: track is clipped by a parent (.jm-slides__track), moved with translate */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-slider-track]', this) || $('.jm-slides__track', this) || $('.jm-books', this) || $('.slider__track', this);
      if (!this.track) return;
      this.prev = $('[data-slider-prev]', this);
      this.next = $('[data-slider-next]', this);
      this.dotsEl = $('[data-slider-dots]', this);
      this.vertical = this.hasAttribute('vertical');
      var ov = getComputedStyle(this.track)[this.vertical ? 'overflowY' : 'overflowX'];
      this.scrollMode = ov === 'auto' || ov === 'scroll';
      this.idx = 0;
      if (this.scrollMode) {
        this._onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this._onScroll, { passive: true });
      } else if (this.vertical) {
        this.track.style.flexDirection = 'column';
      }
      if (this.prev) this.prev.addEventListener('click', function () { this.go(-1); this.userTouch(); }.bind(this));
      if (this.next) this.next.addEventListener('click', function () { this.go(1); this.userTouch(); }.bind(this));
      this.buildDots();
      this._ro = 'ResizeObserver' in window ? new ResizeObserver(this.update.bind(this)) : null;
      if (this._ro) this._ro.observe(this.track);
      this.update();
      var delay = parseInt(this.getAttribute('autoplay'), 10);
      if (delay && !reduceMotion.matches) this.startAutoplay(delay);
    }
    disconnectedCallback() { this.stopAutoplay(); if (this._ro) this._ro.disconnect(); }
    get slides() { return Array.prototype.slice.call(this.track.children); }
    step() {
      var s = this.slides[0];
      if (!s) return 0;
      var cs = getComputedStyle(this.track);
      var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
      if (this.vertical) gap = parseFloat(cs.rowGap) || gap;
      return (this.vertical ? s.offsetHeight : s.offsetWidth) + gap;
    }
    count() { return this.slides.length; }
    maxIndex() {
      if (this.scrollMode) return this.count() - 1;
      return Math.max(0, this.count() - 1);
    }
    pos() { return this.vertical ? this.track.scrollTop : this.track.scrollLeft; }
    scrollMax() { return this.vertical ? this.track.scrollHeight - this.track.clientHeight : this.track.scrollWidth - this.track.clientWidth; }
    show(i) {
      var max = this.maxIndex();
      i = Math.max(0, Math.min(max, i));
      this.idx = i;
      if (this.scrollMode) {
        var p = i * this.step();
        var opts = { behavior: reduceMotion.matches ? 'auto' : 'smooth' };
        if (this.vertical) opts.top = p; else opts.left = p;
        this.track.scrollTo(opts);
      } else {
        this.track.style.transform = (this.vertical ? 'translateY(-' : 'translateX(-') + i * 100 + '%)';
        this.update();
      }
    }
    goTo(i) { this.show(i); this.userTouch(); }
    go(dir) {
      if (this.scrollMode) {
        var st = this.step() || 1;
        var per = Math.max(1, Math.round((this.vertical ? this.track.clientHeight : this.track.clientWidth) / st));
        var cur = Math.round(this.pos() / st);
        this.show(cur + dir * per);
      } else {
        this.show(this.idx + dir);
      }
    }
    currentIndex() {
      if (!this.scrollMode) return this.idx;
      var st = this.step();
      if (this.pos() >= this.scrollMax() - 2 && this.scrollMax() > 0) return this.count() - 1;
      return st ? Math.round(this.pos() / st) : 0;
    }
    buildDots() {
      if (!this.dotsEl) return;
      if (this.dotsEl.children.length) {
        Array.prototype.forEach.call(this.dotsEl.children, function (d, i) { d.addEventListener('click', this.goTo.bind(this, i)); }, this);
        return;
      }
      this.slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', this.goTo.bind(this, i));
        this.dotsEl.appendChild(b);
      }, this);
    }
    onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(function () { this._raf = null; this.update(); }.bind(this));
    }
    update() {
      var i = this.currentIndex();
      var atStart, atEnd;
      if (this.scrollMode) { atStart = this.pos() <= 2; atEnd = this.pos() >= this.scrollMax() - 2; }
      else { atStart = i <= 0; atEnd = i >= this.maxIndex(); }
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
      if (this.dotsEl) {
        Array.prototype.forEach.call(this.dotsEl.children, function (d, n) {
          if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
    }
    userTouch() { if (this._interval) { this.stopAutoplay(); this._userStopped = true; } }
    startAutoplay(delay) {
      var self = this;
      this._delay = delay;
      var tick = function () {
        if (document.hidden || self._paused) return;
        var atEnd = self.scrollMode ? self.pos() >= self.scrollMax() - 2 : self.idx >= self.maxIndex();
        if (atEnd) self.show(0); else self.go(1);
      };
      this._interval = setInterval(tick, delay);
      this.addEventListener('mouseenter', function () { self._paused = true; });
      this.addEventListener('mouseleave', function () { self._paused = false; });
      this.addEventListener('focusin', function () { self._paused = true; });
      this.addEventListener('focusout', function () { self._paused = false; });
      this.addEventListener('touchstart', function () { self._paused = true; }, { passive: true });
      this.addEventListener('touchend', function () { setTimeout(function () { self._paused = false; }, delay); }, { passive: true });
    }
    stopAutoplay() { if (this._interval) { clearInterval(this._interval); this._interval = null; } }
  }
  if (!customElements.get('slider-component')) customElements.define('slider-component', SliderComponent);

  /* ---------------------------------------------------------------- Scroll lock + focus helpers */
  var lockCount = 0;
  function lockScroll() { lockCount++; document.body.classList.add('is-locked'); }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); }
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------------------------------------------------------------- <modal-dialog> */
  class ModalDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = $('dialog', this);
      if (!this.dialog) return;
      this.dialog.addEventListener('click', function (e) {
        if (e.target === this.dialog) this.close();
        else if (e.target.closest('[data-modal-close]')) this.close();
      }.bind(this));
      this.dialog.addEventListener('close', function () { if (this._open) { this._open = false; unlockScroll(); } if (this._opener) this._opener.focus(); }.bind(this));
    }
    open(opener) {
      if (!this.dialog || this.dialog.open) return;
      this._opener = opener || document.activeElement;
      this.dialog.showModal();
      this._open = true;
      lockScroll();
      var f = $('[autofocus], input, ' + FOCUSABLE, this.dialog);
      if (f) f.focus();
    }
    close() { if (this.dialog && this.dialog.open) this.dialog.close(); }
  }
  if (!customElements.get('modal-dialog')) customElements.define('modal-dialog', ModalDialog);

  /* ---------------------------------------------------------------- Drawer base (<cart-drawer>, <menu-drawer>) */
  class DrawerBase extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) this.close();
      }.bind(this));
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key !== 'Tab') return;
        var items = $$(FOCUSABLE, this.panel()).filter(function (el) { return el.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }.bind(this));
    }
    panel() { return $('.drawer__panel', this) || this; }
    open(opener) {
      this._opener = opener || document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      lockScroll();
      this._isOpen = true;
      var p = this.panel();
      var f = $('[data-drawer-close]', p) || p;
      setTimeout(function () { f.focus && f.focus(); }, 60);
      document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id: this.id } }));
    }
    close() {
      if (!this._isOpen) return;
      this._isOpen = false;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (this._opener && this._opener.focus) this._opener.focus();
    }
  }
  class MenuDrawer extends DrawerBase {}
  if (!customElements.get('menu-drawer')) customElements.define('menu-drawer', MenuDrawer);

  /* ---------------------------------------------------------------- Cart */
  var CART_SECTIONS = 'cart-drawer';
  function money(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || JM.moneyFormat || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100.0).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount': default: value = withDelimiters(cents, 2); break;
    }
    return m ? fmt.replace(m[0], value) : fmt;
  }
  JM.formatMoney = money;

  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  class CartDrawer extends DrawerBase {
    connectedCallback() {
      super.connectedCallback();
      if (this._cartBound) return;
      this._cartBound = true;
      this.addEventListener('change', function (e) {
        var input = e.target.closest('input[data-line]');
        if (input) this.updateLine(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0, input.closest('.cart-line'));
      }.bind(this));
      this.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-remove-line]');
        if (rm) { e.preventDefault(); this.updateLine(parseInt(rm.dataset.removeLine, 10), 0, rm.closest('.cart-line')); }
      }.bind(this));
    }
    get count() { return parseInt(this.dataset.itemCount, 10) || 0; }
    render(sectionHTML) {
      if (!sectionHTML) return;
      var doc = parseHTML(sectionHTML);
      var next = $('[data-cart-drawer-content]', doc);
      var cur = $('[data-cart-drawer-content]', this);
      var active = document.activeElement, sel = null;
      if (active && cur && cur.contains(active)) {
        if (active.dataset.line) sel = 'input[data-line="' + active.dataset.line + '"]';
        else if (active.dataset.removeLine) sel = '[data-remove-line="' + active.dataset.removeLine + '"]';
        else if (active.id) sel = '#' + active.id;
        else if (active.hasAttribute('data-drawer-close')) sel = '[data-drawer-close]';
      }
      if (next && cur) cur.innerHTML = next.innerHTML;
      if (sel && this._isOpen) {
        var target = $(sel, this) || $('[data-drawer-close]', this);
        if (target && target.focus) target.focus();
      }
      var nd = $('cart-drawer', doc);
      if (nd) this.dataset.itemCount = nd.dataset.itemCount || '0';
      JM.setCartCount(this.count);
    }
    updateLine(line, qty, row) {
      if (row) row.classList.add('is-updating');
      var self = this;
      JM.cart.change(line, qty).catch(function (err) {
        toast((err && err.message) || 'Could not update cart');
        return fetch(window.location.pathname + '?sections=' + CART_SECTIONS).then(function (r) { return r.json(); })
          .then(function (sections) { self.render(sections[CART_SECTIONS]); }).catch(function () {});
      }).then(function () { if (row && row.isConnected) row.classList.remove('is-updating'); });
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  JM.setCartCount = function (n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.setAttribute('data-empty', n ? 'false' : 'true');
    });
  };
  JM.bumpCart = function () {
    $$('[data-cart-count]').forEach(function (el) {
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  };

  function refreshPageSections(sections) {
    /* Cart page: re-render any element carrying data-cart-section="<id>" */
    $$('[data-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section');
      var html = sections && sections[id];
      if (!html) return;
      var doc = parseHTML(html);
      var fresh = $('[data-cart-section="' + id + '"]', doc);
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
  }
  function sectionIds() {
    var ids = [CART_SECTIONS];
    $$('[data-cart-section]').forEach(function (el) { ids.push(el.getAttribute('data-cart-section')); });
    return ids.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }
  function applySections(sections, opts) {
    var drawer = $('cart-drawer');
    if (drawer && sections && sections[CART_SECTIONS]) {
      drawer.render(sections[CART_SECTIONS]);
      if (opts && opts.open) drawer.open();
    }
    refreshPageSections(sections);
    if (!drawer && sections && sections[CART_SECTIONS]) {
      var nd = $('cart-drawer', parseHTML(sections[CART_SECTIONS]));
      if (nd) JM.setCartCount(parseInt(nd.dataset.itemCount, 10) || 0);
    }
  }

  JM.cart = {
    change: function (line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds().join(','), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (cart.status && (cart.description || cart.message)) throw new Error(cart.description || cart.message);
        applySections(cart.sections);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, action: 'change' } }));
        return cart;
      });
    },
    note: function (note) {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note }) });
    }
  };

  /* window.JM.addToCart(formData | {id, quantity}) */
  JM.addToCart = function (input) {
    var fd;
    if (input instanceof FormData) fd = input;
    else if (input instanceof HTMLFormElement) fd = new FormData(input);
    else {
      fd = new FormData();
      fd.append('id', input.id);
      fd.append('quantity', input.quantity || 1);
      if (input.properties) Object.keys(input.properties).forEach(function (k) { fd.append('properties[' + k + ']', input.properties[k]); });
    }
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        var openDrawer = $('cart-drawer') && document.documentElement.dataset.cartType !== 'page';
        applySections(res.sections, { open: openDrawer });
        JM.bumpCart();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: res, action: 'add' } }));
        if (!openDrawer && document.documentElement.dataset.cartType === 'page') window.location.href = '/cart';
        return res;
      });
  };

  function toast(msg) {
    var t = document.createElement('div');
    t.setAttribute('role', 'alert');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:200;background:var(--ink);color:var(--surface);padding:12px 20px;border-radius:999px;font-weight:700;box-shadow:0 10px 30px rgba(0,0,0,.25);max-width:90vw;';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }
  JM.toast = toast;

  /* Intercept quick-add + product forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    if (form.classList.contains('is-busy')) return;
    var btn = form.querySelector('[type="submit"]') || $('[type="submit"][form="' + form.id + '"]');
    var btns = [btn].concat($$('[type="submit"][form="' + form.id + '"]')).filter(Boolean);
    form.classList.add('is-busy');
    btns.forEach(function (b) { b.classList.add('is-loading'); });
    JM.addToCart(new FormData(form)).then(function () {
      btns.forEach(function (b) { b.classList.add('is-added'); });
      setTimeout(function () { btns.forEach(function (b) { b.classList.remove('is-added'); }); }, 1400);
    }).catch(function (err) { toast(err.message || 'Could not add to cart'); })
      .then(function () { form.classList.remove('is-busy'); btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
  });

  /* ---------------------------------------------------------------- <quantity-input> */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      this.addEventListener('click', function (e) {
        var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
        if (!minus && !plus) return;
        var min = parseInt(this.input.min, 10); if (isNaN(min)) min = 0;
        var v = (parseInt(this.input.value, 10) || 0) + (plus ? 1 : -1);
        var isCartLine = this.input.hasAttribute('data-line');
        if (v < min && !(isCartLine && v === 0)) v = min;
        if (this.input.max && v > parseInt(this.input.max, 10)) v = parseInt(this.input.max, 10);
        this.input.value = v;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }.bind(this));
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  /* ---------------------------------------------------------------- <sticky-header> */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.lastY = window.scrollY;
      this._onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this.measure();
      window.addEventListener('resize', this.measure.bind(this));
      this.onScroll();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this._onScroll); }
    measure() { document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px'); }
    onScroll() {
      var y = window.scrollY;
      var scrolled = y > 24;
      if (scrolled !== this.classList.contains('is-scrolled')) { this.classList.toggle('is-scrolled', scrolled); this.measure(); }
      var locked = document.body.classList.contains('is-locked');
      if (!locked && y > this.offsetHeight + 200 && y > this.lastY + 4) this.classList.add('is-hidden');
      else if (y < this.lastY - 4 || y <= 24) this.classList.remove('is-hidden');
      this.lastY = y;
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  /* ---------------------------------------------------------------- Rotating announcement */
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.announcement__slide', this);
      this.i = 0;
      if (this.slides.length < 2 || reduceMotion.matches) return;
      var speed = (parseInt(this.getAttribute('speed'), 10) || 5) * 1000;
      this._t = setInterval(function () {
        this.slides[this.i].classList.remove('is-active');
        this.i = (this.i + 1) % this.slides.length;
        this.slides[this.i].classList.add('is-active');
      }.bind(this), speed);
    }
    disconnectedCallback() { clearInterval(this._t); }
  }
  if (!customElements.get('announcement-rotator')) customElements.define('announcement-rotator', AnnouncementRotator);

  /* ---------------------------------------------------------------- Global click delegation */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-modal-open]'))) {
      var m = document.getElementById(t.getAttribute('data-modal-open'));
      if (m && m.open) { e.preventDefault(); m.open(t); }
      return;
    }
    if ((t = e.target.closest('[data-drawer-open]'))) {
      var d = document.getElementById(t.getAttribute('data-drawer-open'));
      if (d && d.open) { e.preventDefault(); d.open(t); }
      return;
    }
    if ((t = e.target.closest('[data-cart-open]'))) {
      var cd = $('cart-drawer');
      if (cd && document.documentElement.dataset.cartType !== 'page') { e.preventDefault(); cd.open(t); }
      return;
    }
    if ((t = e.target.closest('.jm-card__wish[data-wishlist]'))) {
      e.preventDefault();
      var h = t.getAttribute('data-wishlist'), list = [];
      try { list = JSON.parse(localStorage.getItem('jm-wishlist') || '[]'); } catch (err) { list = []; }
      var idx = list.indexOf(h);
      if (idx > -1) list.splice(idx, 1); else list.push(h);
      try { localStorage.setItem('jm-wishlist', JSON.stringify(list)); } catch (err) {}
      $$('[data-wishlist="' + h + '"]').forEach(function (b) { b.setAttribute('aria-pressed', idx === -1 ? 'true' : 'false'); });
    }
  });

  function initWishlist() {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('jm-wishlist') || '[]'); } catch (err) { list = []; }
    $$('[data-wishlist]').forEach(function (b) {
      if (list.indexOf(b.getAttribute('data-wishlist')) > -1) b.setAttribute('aria-pressed', 'true');
    });
  }

  /* Cart page line updates (the drawer handles its own) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('input[data-line]');
    if (!input || input.closest('cart-drawer')) return;
    var row = input.closest('.cart-line');
    if (row) row.classList.add('is-updating');
    JM.cart.change(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0).catch(function (err) { toast(err.message); }).then(function () { if (row) row.classList.remove('is-updating'); });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-remove-line]');
    if (!rm || rm.closest('cart-drawer')) return;
    e.preventDefault();
    var row = rm.closest('.cart-line');
    if (row) row.classList.add('is-updating');
    JM.cart.change(parseInt(rm.dataset.removeLine, 10), 0).then(function () {}, function (err) { toast(err.message); });
  });

  /* Cart note on the cart page / drawer */
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-cart-note]')) JM.cart.note(e.target.value);
  });

  /* ---------------------------------------------------------------- Init */
  function init() {
    initReveal();
    initWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initWishlist(); });
  document.addEventListener('shopify:section:select', function (e) { $$('.jm-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); }); });
  document.addEventListener('cart:updated', initWishlist);
})();
